import styled from "styled-components";

const PageWrap = styled.div`
  height: 100%;
  h3:first-child{
    margin-top: 0;
  }
`

export default PageWrap